<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations" style="margin-top: 5px" :style="{ display: operationsDisplay }">
          <div class="filters">
            <el-form
              :inline="true"
              label-position="left"
              @submit.native.prevent="filter.pageNum=1;toQuery()"
            >
              <el-form-item :label="$t('SeaExport.BusinessNo')" label-width="60px">
                <el-input
                  v-model="filter.bizNo"
                  :placeholder="$t('CargoMsg.Cargo_PlsInput')+$t('SeaExport.BusinessNo')"
                  style="width: 150px;"
                  clearable
                />
              </el-form-item>
              <el-form-item
                :label="$t('CargoMsg.Cargo_Company')"
                label-width="40px"
                style="margin-left: 30px"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Office_All"
                  clearable
                  filterable
                  :default-value="filter.officeId"
                  @parentCallBack="p=>{filter.officeId=p.value}"
                />
              </el-form-item>
              <el-form-item
                :label="$t('CargoMsg.Cargo_OperateBy')"
                label-width="50px"
                style="margin-left: 30px"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_User"
                  clearable
                  filterable
                  @parentCallBack="p=>{filter.operationBy=p.value}"
                />
              </el-form-item>
              <el-form-item
                :label="$t('CargoMsg.Cargo_TimeQuery')"
                label-width="60px"
                prop="startDate"
                class="auto-width"
                style="margin-left: 30px"
              >
                <el-date-picker
                  v-model="filter.operationTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
              <el-button type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
            </el-form>
          </div>
        </div>
        <cargo-left-right-resize
          :left-style="{display: 'flex', flexDirection: 'column',width: leftWidth}"
          :right-style="{display: 'flex', flexDirection: 'column',width: rightWidth}"
          :show-right="showRight"
          style="height: 100%"
        >
          <template slot="left">
            <div class="section grid-wrapper" style="height: 100%; padding: 0px">
              <div v-if="source !== 'HomePage'" style="background-color: #F5F7F6; padding: 10px;border-bottom: 1px solid #DDE0E7">
                <div style="border-right: 1px solid #DBDFE1">
                  <span style="margin-left: 20px">{{ $t('CargoMsg.Cargo_BusinessOperationUpdateDynamics') }}</span>
                </div>
              </div>
              <cargo-group :groups="actionLogGroupData" :current-row-id="currentRowId" :show-right="showRight" style="margin-left: 37px; height: 100px; overflow: auto; display: flex; flex: 1 1 auto; flex-direction: column" @change="groupClickHandle" />
              <cargo-ag-grid-no-row-overlay v-if="total<=0" />
            </div>
          </template>
          <template slot="right">
            <div class="section grid-wrapper" style="height: 100%; padding: 0px;">
              <div v-if="source !== 'HomePage'" style="background-color: #F5F7F6; padding: 10px;border-bottom: 1px solid #DDE0E7">
                <div style="border-right-width: 1px; border-right-style: solid; border-right-color: #DBDFE1; display: flex; justify-content: space-between">
                  <span style="margin-left: 20px">{{ $t('CargoMsg.Cargo_UpdateDetails') }}</span>
                  <i class="el-icon-close close" @click="detailCloseHandle" />
                </div>
              </div>
              <div style="padding: 10px;border-bottom: 1px solid #DDE0E7; margin-left: 20px">
                <div style="display: flex;flex-direction: row;justify-content: space-between">
                  <div style="display: flex">
                    <span style="align-self: center">{{ $t('CargoMsg.Cargo_UpdateContent') }}</span>
                  </div>
                  <div style="display: flex">
                    <el-input v-model="searchText" clearable style="width: 300px" :placeholder="$t('CargoMsg.Cargo_ResultsDisplayedInYellow')" @keyup.enter.native="findText" />
                    <el-button style="margin-left: 5px" type="primary" @click="findText">{{ $t('common.btn.query') }}</el-button>
                  </div>
                </div>
              </div>
              <div style="padding: 10px;margin-left: 20px; overflow: auto; display: flex; flex: 1 1 auto; flex-direction: column">
                <data-update-log-detail class="find-text-area" :detail="detail" style=" height: 100px;" />
              </div>
            </div>
          </template>
        </cargo-left-right-resize>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="total>0 && source !== 'HomePage'"
            config-module="10000001"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
          <div v-show="total>0 && source === 'HomePage'" style="min-height:30px;height:100%;position:relative">
            <div style="position:absolute;right:5px">
              <cargo-pagination
                config-module="10000002"
                :total="total"
                :page.sync="filter.pageNum"
                :limit.sync="filter.pageSize"
                @pagination="toQuery"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { getActionLogAttribute } from '@/utils/ActionLogAttributeConstants'
import cargoGroup from '@/components/Cargo/Common/cargoGroup'
import dataUpdateLogDetail from '@/components/Cargo/Job/dataUpdateLogDetail'
import { getActionLogList } from '@/api/actionLog'
import DateUtils from '@/utils/dateUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ActionLogUtil } from '@/class/cargo/model/utils/ActionLogUtil'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { mapGetters } from 'vuex'
import { DocumentManage } from '@/utils/commonUtil'
import { getJobByUuid } from '@/api/booking/job'
import { jumpBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import CargoAgGridNoRowOverlay from '@/components/Cargo/Common/CargoAgGridNoRowsOverLay'
import { LOG_OPERATION_TYPE_ADD, LOG_OPERATION_TYPE_DELETE } from '@/class/cargo/model/parameters/SystemConstants'
import { loadCharges } from '@/api/clearing/charge'
import { User } from '@/class/model/sys/User'

export default {
  name: 'DataUpdateLog',
  components: { CargoUserSelect, cargoLeftRightResize, cargoGroup, dataUpdateLogDetail, cargoOfficeSelect, CargoAdvanceSelect, CargoAgGridNoRowOverlay },
  props: {
    source: { type: String, default: 'SystemMonitor' }
  },
  data() {
    return {
      searchModel: SystemConstants.SEARCH_MODEL,
      filter: {
        bizNo: null,
        officeId: null,
        operationBy: null,
        operationTime: [DateUtils.formatStandardDate(new Date()) + ' 00:00:00', DateUtils.formatStandardDate(new Date()) + ' 23:59:59'],
        pageNum: 1,
        pageSize: this.source !== 'HomePage' ? 20 : 10
      },
      total: 0,
      viewDialog: {
        visible: false,
        content: ''
      },
      // getActionLogAttribute: getActionLogAttribute,
      detail: [],
      actionLogGroupData: [],
      leftWidth: '50%',
      rightWidth: '50%',
      showRight: false,
      selectTypeNames: TYPE_NAMES,
      documentManage: new DocumentManage(),
      searchText: null,
      currentRowId: 0,
      operationsDisplay: this.source !== 'HomePage' ? '' : 'none',
      privilege: {
        queryArAllRole: this.$checkPermission(['role_Charge_queryArAll']),
        queryArDeptChargeRole: this.$checkPermission(['role_Charge_queryArDeptCharge']),
        queryArUserChargeRole: this.$checkPermission(['role_Charge_queryArUserCharge']),
        queryApAllRole: this.$checkPermission(['role_Charge_queryApAll']),
        queryApDeptChargeRole: this.$checkPermission(['role_Charge_queryApDeptCharge']),
        queryApUserChargeRole: this.$checkPermission(['role_Charge_queryApUserCharge']),
        isCostControlled: this.$checkPermission(['button_Charge_costControlled']), // 是否有应收受控费用权限
        isControlled: this.$checkPermission(['button_Charge_controlled']) // 是否有同组查看权限
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentOfficeId',
      'tenantId',
      'userInfo'
    ]),
    routes() {
      return this.$store.state.permission.routes
    }
    // ,
    // isHomePage() {
    //   return this.source !== 'HomePage' ? '' : 'none'
    // }
  },
  watch: {
    searchText(val) {
      if (!val) {
        this.findText()
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('jumpToBussiness', function(operationSource, operationType, objectId) {
      context.jumpToBussiness(operationSource, operationType, objectId)
    })
  },
  created() {
    this.toQuery()
  },
  methods: {
    async toQuery() {
      if (this.source === 'HomePage') {
        // 首页只查询近三天数据
        this.filter.operationBeginDate = DateUtils.formatStandardDate(new Date(new Date() - (3 * 24 * 60 * 60 * 1000))) + ' 00:00:00'
        this.filter.operationEndDate = DateUtils.formatStandardDate(new Date()) + ' 23:59:59'
      } else if (this.filter.operationTime) {
        this.filter.operationBeginDate = this.filter.operationTime[0]
        this.filter.operationEndDate = DateUtils.formatStandardDate(new Date(this.filter.operationTime[1])) + ' 23:59:59'
      } else {
        delete this.filter.operationBeginDate
        delete this.filter.operationEndDate
      }
      if (this.source === 'HomePage' && !(this.$store.getters.isAdmin)) {
        const operationList = []
        operationList.push(this.$store.getters.userId)
        this.filter.operationByList = operationList
      }
      const loading = getLoading()
      await getActionLogList(this.filter).then(async res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          await ActionLogUtil.analyseOperationJson(res.data.list)
          this.total = parseInt(res.data.total)
          let excludeActionLogIds = []
          // CARGO-36855 费用页签操作日志--串入 个人、同组、受控 权限
          const chargeActionLogs = res.data.list.filter(actionLog => actionLog.objectKey === 'charge' && actionLog.operationType !== LOG_OPERATION_TYPE_DELETE.code && !actionLog.operationSource.endsWith('ChargeAdvance'))
          if (chargeActionLogs.length > 0) {
            const chargeIds = chargeActionLogs.map(actionLog => parseInt(actionLog.operationParams.split('\n')[1]))
            const charges = await loadCharges({ chargeIds: Array.from(new Set(chargeIds)) }).then(res => {
              return res.data
            })
            // 获取不满足【个人、同组 权限】的chargeIds
            if (charges && charges.length > 0) {
              // 查询同部门的人
              const departmentTeamUser = await User.getUserDepartmentTeam()
              const excludeChargeIds = []
              charges.forEach(charge => {
                if (charge.receivable) {
                  if (charge.controlled && !this.privilege.isCostControlled) {
                    // 受控
                    excludeChargeIds.push(charge.chargeId)
                    return
                  }
                  // 应收
                  if (this.privilege.queryArAllRole) {
                    // 所有
                    return
                  } else if (this.privilege.queryArDeptChargeRole && departmentTeamUser && departmentTeamUser.length > 0) {
                    // 同组
                    if (!this.checkDepartmentTeam(charge, departmentTeamUser)) {
                      excludeChargeIds.push(charge.chargeId)
                      return
                    }
                  } else if (charge.createdBy !== this.$store.getters.userId && charge.createdBy > 0) {
                    // 个人
                    excludeChargeIds.push(charge.chargeId)
                    return
                  }
                } else {
                  if (charge.controlled && !this.privilege.isControlled) {
                    // 受控
                    excludeChargeIds.push(charge.chargeId)
                    return
                  }
                  // 应付
                  if (this.privilege.queryApAllRole) {
                    // 所有
                    return
                  } else if (this.privilege.queryApDeptChargeRole && departmentTeamUser && departmentTeamUser.length > 0) {
                    // 同组
                    if (!this.checkDepartmentTeam(charge, departmentTeamUser)) {
                      excludeChargeIds.push(charge.chargeId)
                      return
                    }
                  } else if (charge.createdBy !== this.$store.getters.userId && charge.createdBy > 0) {
                    // 个人
                    excludeChargeIds.push(charge.chargeId)
                    return
                  }
                }
              })
              // 将excludeChargeIds排除
              if (excludeChargeIds.length > 0) {
                excludeActionLogIds = [...(res.data.list.filter(actionLog => actionLog.objectKey === 'charge' && excludeChargeIds.includes(parseInt(actionLog.operationParams.split('\n')[1]))).map(actionLog => actionLog.id))]
              }
            }
          }

          const groupMap = new Map()
          for (const actionLog of res.data.list) {
            // 详情区域：fieldName、label处理
            if (actionLog.actionItems && actionLog.actionItems.length > 0) {
              if (actionLog.operationType === LOG_OPERATION_TYPE_ADD.code) {
                actionLog.actionItems = actionLog.actionItems.filter(item => {
                  const attribute = getActionLogAttribute(item.attributeKey)
                  // 新增时，有些字段后端会赋值初始值0，而其值在前端没有意义，该记录不展示（zeroMeaningLess：true-无意义，默认无值-有意义）
                  return !(attribute && attribute.labelFunc && attribute.zeroMeaningLess && item.newValue === '0')
                })
              }
              // 无查看费用权限数据的日志处理，将明细中的value替换成****（因为权限是前端控制的，要保持分页条数正确，就不能进行过滤，使用替换成****的方式）
              if (excludeActionLogIds.includes(actionLog.id)) {
                for (const item of actionLog.actionItems) {
                  if (item.attributeKey === 'fileHistory.FILE_NAME') {
                    item.content = this.$t('CargoMsg.Cargo_Delete') + '《****》'
                    continue
                  }
                  const attribute = getActionLogAttribute(item.attributeKey)
                  if (attribute) {
                    item.content = attribute.fieldName + ' : **** -----> ****'
                  }
                }
              } else {
                for (const item of actionLog.actionItems) {
                  if (item.attributeKey === 'fileHistory.FILE_NAME') {
                    item.content = this.$t('CargoMsg.Cargo_Delete') + '《' + item.newValue + '》'
                    continue
                  }
                  const attribute = getActionLogAttribute(item.attributeKey)
                  if (attribute) {
                    item.fieldName = attribute.fieldName
                    if (attribute.labelFunc) {
                      if (item.oldValue !== null && item.oldValue !== '') {
                        item.oldValueLabel = await attribute.labelFunc(item.oldValue)
                        if ((item.oldValueLabel === null || item.oldValueLabel === '' || item.oldValueLabel === 'undefined' || item.oldValueLabel === '状态未知' || item.oldValueLabel === 'Status unknown') && !isNaN(parseInt(item.oldValue))) {
                          item.oldValueLabel = await attribute.labelFunc(parseInt(item.oldValue))
                        }
                      }
                      if (item.newValue !== null && item.newValue !== '') {
                        item.newValueLabel = await attribute.labelFunc(item.newValue)
                        if ((item.newValueLabel === null || item.newValueLabel === '' || item.newValueLabel === 'undefined' || item.newValueLabel === '状态未知' || item.newValueLabel === 'Status unknown') && !isNaN(parseInt(item.newValue))) {
                          item.newValueLabel = await attribute.labelFunc(parseInt(item.newValue))
                        }
                      }
                    } else {
                      item.oldValueLabel = item.oldValue
                      item.newValueLabel = item.newValue
                    }
                    item.content = item.fieldName + ' : ' + (item.oldValueLabel ? item.oldValueLabel : this.$t('CargoMsg.Empty')) + ' -----> ' + (item.newValueLabel ? item.newValueLabel : this.$t('CargoMsg.Empty'))
                  }
                }
              }
            }
            const jumpToBussiness = this.documentManage.getPath('jumpToBussiness')
            const bizNoStr = actionLog.operationType === LOG_OPERATION_TYPE_DELETE.code ? `<span style="color:grey">${actionLog.bizNo}</span>` : `<a href="#" onclick="event.stopPropagation();${jumpToBussiness}('${actionLog.operationSource}','${actionLog.operationType}','${actionLog.objectId}')" style="color:blue">${actionLog.bizNo}</a>`
            actionLog.content = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', actionLog.operationBy, 'chineseName') + ' ' +
              ActionLogUtil.getOperationTypeName(actionLog.operationType) + ' ' +
              bizNoStr +
              '【' + await ActionLogUtil.getOperationSourceNameTab(actionLog) + '】' + this.$t('CargoMsg.Cargo_Infomation') + '        '
            actionLog.content1 = actionLog.operationTime
            const operationTime = DateUtils.formatStandardDate(actionLog.operationTime)
            if (groupMap.has(operationTime)) {
              groupMap.get(operationTime).push(actionLog)
            } else {
              groupMap.set(operationTime, [actionLog])
            }
          }
          const actionLogGroupData = []
          groupMap.forEach((actionLogs, operationTime) => {
            actionLogGroupData.push({
              'title': operationTime + ' ' + this.$t('CargoMsg.Cargo_Reflush'),
              'isExpanded': false,
              'items': actionLogs
            })
          })
          // 最新一天默认展开
          if (actionLogGroupData && actionLogGroupData.length > 0) {
            actionLogGroupData[0].isExpanded = true
          }
          this.actionLogGroupData = actionLogGroupData
          // console.log('actionLogGroupData:' + JSON.stringify([...actionLogGroupData]))
        } else {
          this.actionLogGroupData = []
          this.total = 0
        }
        this.currentRowId = 0
        this.detail = []
        this.showRight = false
      }).finally(() => loading.close())
    },
    opChangeHandler(params) {
      this.filter.op = params.value
    },
    groupClickHandle(row) {
      if (this.currentRowId !== row.id) {
        this.searchText = null
        this.currentRowId = row.id
        this.detail = row.actionItems
        this.showRight = true
      } else {
        this.showRight = !this.showRight
      }
    },
    detailCloseHandle() {
      this.showRight = false
    },
    async jumpToBussiness(operationSource, operationType, objectId) {
      // 【业务】
      if (operationType === LOG_OPERATION_TYPE_DELETE.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BusinessNotExist'))
        return
      }
      if (SystemConstants.getCommonState(operationSource, SystemConstants.LOG_OPERATION_SOURCE)) {
        const job = await getJobByUuid(objectId).then(res => res.data)
        if (!job) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BusinessNotExist'))
          return
        }
        jumpBusiness(this, job.uuid, job.jobNo, job.lob, job.opOffice, operationSource)
      }
    },
    findText() {
      this.clearFindText()
      const searchTerm = this.searchText.trim()
      if (searchTerm) {
        const contentElements = document.querySelectorAll('.find-text-area span')
        contentElements.forEach(contentElement => {
          const keys = this.searchText.trim().split(/\s+/)
          keys.forEach((key) => {
            const reg = new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
            contentElement.innerHTML = contentElement.innerHTML.replace(reg, `<span style="background-color: yellow;">$&</span>`)
          })
        })
      }
    },
    clearFindText() {
      const regex = /<span style="background-color: yellow;">(.*?)<\/span>/g
      const contentElements = document.querySelectorAll('.find-text-area span')
      contentElements.forEach(contentElement => {
        contentElement.innerHTML = contentElement.innerHTML.replace(regex, '$1')
      })
    }
  }
}
</script>

<style lang="scss">
</style>
